import { f as format } from './defaults-1329a7d1.js';
import { useState, useMemo, useCallback } from 'react';

var useResolvedDateValue = function (value, onValueChangeProp, dateFormat) {
    var _a = useState(value), thisValue = _a[0], setThisValue = _a[1];
    var resolvedValue = useMemo(function () { return value || thisValue; }, [thisValue, value]);
    var onValueChange = useCallback(function (newValue) {
        if (onValueChangeProp) {
            onValueChangeProp(newValue);
        }
        if (!value) {
            setThisValue(newValue);
        }
    }, [onValueChangeProp, value]);
    var getFormattedValue = useCallback(function () {
        if (!resolvedValue)
            return;
        if (typeof dateFormat === "function") {
            return dateFormat(resolvedValue);
        }
        return format(resolvedValue, dateFormat);
    }, [dateFormat, resolvedValue]);
    return { resolvedValue: resolvedValue, onValueChange: onValueChange, getFormattedValue: getFormattedValue };
};

export { useResolvedDateValue as u };
